import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/ar-images/icon/cbys-icon.png'
import _imports_1 from '@/assets/images/ar-images/icon/cjys-icon.png'


const _hoisted_1 = { class: "spatia-vision" }
const _hoisted_2 = { class: "boot-first" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "wmdys" }

import { ref } from 'vue'
import { modelTypes } from '@/config';
import SubTitle from '@/components/SubTitle.vue';
import ExampleIntroduction from '@/components/common/ExampleIntroduction.vue';
import { exampleDatas } from '@/config/index'

const MODEL = 'vision_ar'


export default /*@__PURE__*/_defineComponent({
  __name: 'SpatialVision',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("header", null, [
        _createTextVNode("为你构建室内外稳定的"),
        _createElementVNode("span", null, "空间计算能力")
      ], -1)),
      _createElementVNode("main", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(modelTypes)[MODEL], (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            key: item.header
          }, [
            _createElementVNode("img", {
              src: item.image,
              alt: ""
            }, null, 8, _hoisted_3),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h3", null, _toDisplayString(item.header), 1),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.remarkList, (remark) => {
                  return (_openBlock(), _createElementBlock("li", { key: remark }, _toDisplayString(remark), 1))
                }), 128))
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(SubTitle, {
        "mode-class": "black-style",
        "title-text": "我们的优势"
      }),
      _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"wmdys-content\" data-v-1ca4eb25><div class=\"left\" data-v-1ca4eb25><header data-v-1ca4eb25><img src=\"" + _imports_0 + "\" class=\"l-iamge\" alt=\"\" data-v-1ca4eb25><div class=\"r-head\" data-v-1ca4eb25>成本优势</div></header><div class=\"line\" data-v-1ca4eb25>· 技术使用成本低；</div><div class=\"line\" data-v-1ca4eb25>· 云SAAS化服务降低使用门槛。</div></div><div class=\"right\" data-v-1ca4eb25><header data-v-1ca4eb25><img src=\"" + _imports_1 + "\" class=\"l-iamge\" alt=\"\" data-v-1ca4eb25><div class=\"r-head\" data-v-1ca4eb25>场景优势</div></header><div class=\"line\" data-v-1ca4eb25>· 现实空间三维建模、复杂环境感知、视觉导航上优势显著；</div><div class=\"line\" data-v-1ca4eb25>· 在机器人、自动驾驶、医疗、消费电子等领域具备可拓展前景。</div></div></div>", 1))
    ]),
    _createVNode(ExampleIntroduction, {
      exampleData: _unref(exampleDatas).kjsj
    }, null, 8, ["exampleData"])
  ]))
}
}

})